/**
 * @module actions/customerGroup
 */
import axios from 'axios'
import {
  API_URL,
  SET_CUSTOMERGROUPS
} from '../constants'

/**
 * @description Get list of customergroups from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getCustomerGroups () {
  let url = API_URL + '/CustomerGroup'
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERGROUPS,
        customergroups: res.data
      })
      return res
    })
  }
}

/**
 * @description Get customer group from API
 * @return {Promise} Axios promise
 */
export function getCustomerGroup (id) {
  let url = API_URL + '/CustomerGroup/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting customers from customergroup, with shop name from the API
 * @return {Promise} Axios promise
 */
export function getShopCustomers (customerGroupId) {
  let url = API_URL + '/CustomerGroup/ShopCustomers/' + customerGroupId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get chain customers from API
 * @return {Promise} Axios promise
 */
export function getChainCustomers (chainId) {
  let url = API_URL + '/CustomerGroup/ChainCustomers/' + chainId
  return dispatch => {
    return axios.get(url)
  }
}
/**
 * @description Create/save customer group
 * @return {Promise} Axios promise
 */
export function CreateSaveCustomerGroup (data) {
  let url = API_URL + '/CustomerGroup/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description add customers to customer group
 * @return {Promise} Axios promise
 */
export function addCustomerGroupCustomers (data) {
  let url = API_URL + '/CustomerGroup/Customer/Add'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description Remove customer from customergroup
 * @return {Promise} Axios promise
 */
export function removeCustomerGroupCustomer (data) {
  let url = API_URL + '/CustomerGroup/Customer/Remove'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting shops for customergroup from API
 * @return {Promise} Axios promise
 */
export function getShopsForCustomerGroup (id) {
  let url = API_URL + '/CustomerGroup/Shop/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get customerGroup agreements by companyId
 * @return {Promise} Axios promise
 */
export function getCustomerGroupAgreements (id) {
  let url = API_URL + '/CustomerGroup/Shop/Agreements/' + id
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/customerGroup.js